import { render, staticRenderFns } from "./EditarTicket.vue?vue&type=template&id=80547046"
import script from "./EditarTicket.vue?vue&type=script&lang=js"
export * from "./EditarTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports